
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $cc354da94432fceb$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["jafTj","game.4cb45e20.js","1Mr4B","esm.41c3cc02.js","jLls5","Index-402c7919.580ad9bf.js","61CYG","Index-b0741ea5.6627d03a.js","7RU8N","metamask.e118dd7e.js","dOEWM","infinitywallet.d1e8cf6e.js","3M8Th","exodus.63cc5bf0.js","hM5jg","frontier.b54826c4.js","l2YA8","brave.e6637934.js","hSZsE","binance.55838fb6.js","kUBQp","coinbase.1e4193fd.js","4E6cO","detected.c29d7f85.js","kPrzs","trust.5bd843da.js","6cyn7","opera.ec7ad0d7.js","1vV0A","status.257af8ba.js","f8wXH","alphawallet.34f72d49.js","8rnp7","apexwallet.19db3eaf.js","coZkB","atoken.56986814.js","hofEg","bifrostwallet.54c5a048.js","dCigr","bitpie.c36575b6.js","zaPCJ","blockwallet.1f9b039d.js","lCEBY","frame.49fbdf6a.js","cZDHO","huobiwallet.2c35d230.js","1Ohg0","hyperpay.3cbb566d.js","fyqb4","imtoken.f0eee843.js","eJhML","liquality.292a92e1.js","8dIyi","meetone.d1158fac.js","itMxT","mykey.a0740781.js","lD49O","ownbit.322c11d7.js","6gvC0","tokenpocket.c910fbcc.js","hKM2U","tp.4160858f.js","hm4LN","xdefi.844c08f4.js","9njq9","oneInch.66def34b.js","gcwDV","tokenary.2ec33c3d.js","7BRSq","tallywallet.981f1114.js","61hP4","zeal.490bf7ee.js","dETuu","rabby.a756d855.js","5C23A","mathwallet.ef283468.js","1GoKa","bitget.7e606d12.js","3c8No","sequence.2f6c80b8.js","kvrX1","core.84504a35.js","ebw82","bitski.e523b1bc.js","er3V6","zerion.fcfb59f3.js","1wJUp","enkrypt.f540a3be.js","aQ7qs","phantom.7f61c7f4.js","4USHL","safepal.08005955.js","jT7YW","rainbow.f40d1665.js","8pjKT","okxwallet.5f5db4cc.js","gZXE0","defiwallet.a7e19bdb.js","1dPRA","safeheron.82c8bfd6.js","8B3IS","talisman.86abd4f5.js","3WWP9","roninwallet.b7db109a.js","8TIJD","onekey.8ffa65ee.js","6Ofxf","fordefi.1b84ea1e.js","f3whp","coin98wallet.03ed38b8.js","69iDJ","subwallet.38a5f9f3.js","9pTu2","kayros.65b7daf0.js","aYuan","foxwallet.84e3ec3d.js","kZofj","lif3wallet.39f9b41f.js"]'));


//# sourceMappingURL=game.runtime.6ff8375c.js.map
